import React from 'react';
import cssmodules from 'react-css-modules';
import styles from './signoutpage.cssmodule.scss';
import {injectIntl, intlShape, FormattedRelative} from 'react-intl';


class SignOutPage extends React.Component {

  render() {
    const {intl} = this.props;
    const t = (message, data = {}) => {
        return intl.formatMessage({id : message}, data);
    };

    return (
      <div className="container signoutpage-component" styleName="signoutpage-component">
        <div className="row">
            <div className="col-md-12">
                <div className="error-template" styleName="error-template">
                    <h1>
                        {t('Thank you')} !
                    </h1>
                    <div className="error-details">
                        {t('SEE_YOU_AGAIN')}  !
                    </div>
                    <br />
                    <img src="/images/logo.gif"/>
                    <br/><br/><br/><br/>
                    <div className="error-actions">
                        <a href="/" className="btn btn-default btn-lg btn-brand"><span className="glyphicon glyphicon-home"></span> &nbsp; {t('Sign in again')}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
  }
}

SignOutPage.displayName = 'SignOutPage';
SignOutPage.propTypes = {};
SignOutPage.defaultProps = {};

export default injectIntl(cssmodules(SignOutPage, styles));



// WEBPACK FOOTER //
// ./components/SignOut/SignOutPage.js